import { useParams, Link, useNavigate } from "react-router-dom";
import {
  ArrowLeft,
  Calendar,
  Share2,
  Facebook,
  Twitter,
  Linkedin,
} from "lucide-react";
import { useArticleContext } from "../context/ArticleContext";
import { useEffect, useState } from "react";

export default function ArticleDetail() {
  const { id } = useParams();
  const navigate = useNavigate();

  const {selectedArticle, fetchArticleById, articles} = useArticleContext();
  const relatedArticles = articles.filter((a) => a.id !== parseInt(id)).slice(0, 3);

  useEffect(() => {
      fetchArticleById(id);
    }, [id]);

  if (!selectedArticle) {
    return (
      <div className="max-w-7xl mx-auto px-4 py-16 text-center">
        <h2 className="text-2xl font-bold mb-4 text-[#7a6e5f]">Article not found</h2>
        <button
          onClick={() => navigate("/articles")}
          className="text-[#809080] hover:underline inline-flex items-center gap-2"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Articles
        </button>
      </div>
    );
  }

  return (
    <div className="bg-[#fef8f5]">
      <div className="max-w-7xl mx-auto px-4 py-16">
        <button
          onClick={() => navigate("/articles")}
          className="mb-8 text-[#7a6e5f] hover:text-[#809080] inline-flex items-center gap-2"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Articles
        </button>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          {/* Main Content */}
          <div className="lg:col-span-2">
            <img
              src={`${process.env.REACT_APP_API_URL}/storage/${selectedArticle.image}`}
              alt={selectedArticle.title}
              className="w-full h-[400px] object-cover rounded-xl mb-8"
            />

            <div className="flex items-center gap-6 text-[#7a6e5f] mb-6">
              <div className="flex items-center gap-2 text-sm">
                <Calendar className="w-4 h-4" />
                {new Date(selectedArticle.created_at).toLocaleDateString("en-GB")}
              </div>
            </div>

            {/* <h1 className="text-4xl font-serif font-bold text-[#7a6e5f] mb-6">{selectedArticle.title}</h1>

            <div className="text-[#7a6e5f] space-y-6 leading-relaxed">
              <p>{selectedArticle.excerpt}</p> */}

              <h1 className="text-4xl font-serif font-bold text-[#7a6e5f] mb-3">
  {selectedArticle.title}
</h1>

<p className="text-lg text-[#7a6e5f] italic opacity-80 mb-6">
  {selectedArticle.excerpt}
</p>

<div className="text-[#7a6e5f] space-y-6 leading-relaxed">
  {/* Main content goes here */}
              {/* <h2 className="text-2xl font-bold mt-8">The Evolution of Skincare</h2>
              <p>
                Modern skincare has evolved into something more mindful and intentional. It’s not just
                about looking good—it’s about feeling connected to your skin, using ingredients that
                nourish and protect it.
              </p>
              <blockquote className="border-l-4 border-[#809080] pl-4 italic text-[#7a6e5f]">
                "Skincare is a ritual of self-respect—gentle, grounding, and unique to you."
              </blockquote>
              <p>
                At SuprSkin, we believe every formula should respect both your skin and the planet.
                That’s why our journal is more than a blog—it’s a space to deepen your skincare journey.
              </p> */}

              <div dangerouslySetInnerHTML={{
                __html: selectedArticle.content
              }}>

              </div>
            </div>

            {/* Share Section */}
            <div className="border-t border-[#e2dcd3] mt-12 pt-8">
              <div className="flex items-center gap-4">
                <span className="font-semibold text-[#7a6e5f] flex items-center gap-2">
                  <Share2 className="w-5 h-5" />
                  Share this article
                </span>
                <div className="flex gap-4">
                  <button className="p-2 hover:bg-[#f5eee6] rounded-full">
                    <Facebook className="w-5 h-5 text-[#7a6e5f]" />
                  </button>
                  <button className="p-2 hover:bg-[#f5eee6] rounded-full">
                    <Twitter className="w-5 h-5 text-[#7a6e5f]" />
                  </button>
                  <button className="p-2 hover:bg-[#f5eee6] rounded-full">
                    <Linkedin className="w-5 h-5 text-[#7a6e5f]" />
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <div className="lg:col-span-1">
            <div className="sticky top-24">
              <h2 className="text-2xl font-bold mb-6 text-[#7a6e5f]">Related Articles</h2>
              <div className="space-y-6">
                {relatedArticles.map((relatedArticle) => (
                  <Link
                    key={relatedArticle.id}
                    to={`/articles/${relatedArticle.id}`}
                    className="flex gap-4 group"
                  >
                    <div className="w-24 h-24 overflow-hidden rounded-lg">
                      <img
                        src={`${process.env.REACT_APP_API_URL}/storage/${relatedArticle.image}`}
                        alt={relatedArticle.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                      />
                    </div>
                    <div className="flex-1">
                      <h3 className="font-medium text-[#7a6e5f] group-hover:text-[#809080] transition-colors">
                        {relatedArticle.title}
                      </h3>
                      <div className="text-sm text-[#7a6e5f] opacity-70">
                        <div className="flex items-center gap-1">
                          <Calendar className="w-4 h-4" />
                          {new Date(relatedArticle.created_at).toLocaleDateString("en-GB")}
                        </div>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>

              {/* Author Info */}
              <div className="mt-12 p-6 bg-[#f5eee6] rounded-xl text-[#7a6e5f]">
                <div className="flex items-center gap-4 mb-4">
                  <img
                    src={`${process.env.REACT_APP_API_URL}/storage/${selectedArticle.author_image}`}
                    alt={selectedArticle.author}
                    className="w-16 h-16 rounded-full object-cover"
                  />
                  <div>
                    <h3 className="font-semibold">{selectedArticle.author}</h3>
                    <p className="text-sm opacity-70">Skin Wellness Writer</p>
                  </div>
                </div>
                <p className="text-sm opacity-80">
                  {selectedArticle.author} writes about skincare and self-care with a warm, approachable voice.
                  Expect real talk, gentle tips, and lots of love for your natural glow.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
